/**
 * Het scherm van de leerkracht: vijf tabbladen, elk in een eigen bestand in
 * tabs/.
 *
 *   Groepen        groepen en leerlingen
 *   Teksten        de teksten bekijken, op elk niveau, met hun toetsen
 *   Lessen         lessen aanmaken, bekijken en aanzetten; afwijkingen per leerling
 *   Resultaten     de scores per leerling per les
 *   Ontwikkeling   de groeicurve per leerling
 *
 * Op het scherm heten ze groepen en lessen, in de server classes en
 * sessions. Een tabblad dat eenmaal open is geweest, blijft bestaan als je
 * naar een ander gaat (het wordt alleen verborgen), zodat een gekozen groep
 * of een half ingevulde les blijft staan. Bij elke keer openen haalt het
 * tabblad zijn gegevens opnieuw op.
 */
import React, { useState } from 'react';
import { BarChart3, ClipboardList, FileText, TrendingUp, Users } from 'lucide-react';
import { Kop } from '../../components/Kop';
import { Groepen } from './tabs/Groepen';
import { Lessen } from './tabs/Lessen';
import { Ontwikkeling } from './tabs/Ontwikkeling';
import { Resultaten } from './tabs/Resultaten';
import { Teksten } from './tabs/Teksten';

const TABS = [
  { id: 'groepen', label: 'Groepen', icon: Users, Tab: Groepen },
  { id: 'teksten', label: 'Teksten', icon: FileText, Tab: Teksten },
  { id: 'sessies', label: 'Lessen', icon: ClipboardList, Tab: Lessen },
  { id: 'resultaten', label: 'Resultaten', icon: BarChart3, Tab: Resultaten },
  { id: 'ontwikkeling', label: 'Ontwikkeling', icon: TrendingUp, Tab: Ontwikkeling },
];

function LeerkrachtDashboard({ user, onLogout }) {
  const [actief, setActief] = useState('groepen');
  const [geopend, setGeopend] = useState(['groepen']);
  const [fout, setFout] = useState('');

  const kies = (id) => {
    setActief(id);
    setGeopend(prev => (prev.includes(id) ? prev : [...prev, id]));
  };

  return (
    <div>
      <Kop naam={user.naam} onLogout={onLogout} tabs={TABS} actief={actief} kiesTab={kies} />
      <div className="container">
        {fout && <div className="alert alert-error">{fout}</div>}
        {TABS.filter(t => geopend.includes(t.id)).map(({ id, Tab }) => (
          <div key={id} hidden={actief !== id}>
            <Tab actief={actief === id} meldFout={setFout} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default LeerkrachtDashboard;
